var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"slice-board-list text-16 md_text-20 xl_text-24 md_px-20 my-50 md_my-70"},[_c('div',{staticClass:"md_w-6x12 mx-auto px-20 text-columns-2 text-column-gap-40 md_text-column-gap-20"},_vm._l((_vm.slice.list),function(item){return _c('li',[_vm._v(_vm._s(item.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }